import { render, staticRenderFns } from "./SelectGroupMembers.vue?vue&type=template&id=8c84b0d8&scoped=true"
import script from "./SelectGroupMembers.vue?vue&type=script&lang=js"
export * from "./SelectGroupMembers.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SelectGroupMembers.vue?vue&type=style&index=1&id=8c84b0d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c84b0d8",
  null
  
)

export default component.exports